import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "src/store";
import { formatJsonResponse } from "src/stores/vs-product";
import { API_PROD_URL } from "src/utils/axios";

export const sendAiAgentQuery = createAsyncThunk(
  "sendQuery",
  async (
    {
      agentName,
      user_input,
      user_id,
      thread_id,
      sendPitchData,
      file_upload_status,
      shouldRename,
      step,
      jsonType,
    }: {
      agentName?: string;
      user_input: string;
      user_id: string;
      thread_id: string;
      sendPitchData?: boolean;
      file_upload_status?: boolean;
      shouldRename?: boolean;
      step?: number;
      jsonType?: string;
    },
    { getState },
  ): Promise<any> => {
    const ipExperts: Record<string, string> = {
      "Prior Art Agent": "prior_art_agent",
      "FTO Agent": "fto_agent",
      "Patent Licensing Agent": "patent-license-agent",
      "Patent Landscape Agent": "landscape_agent",
      "Prosecution History Agent": "file_wrapper_agent",
    };
    const state = getState() as RootState;
    const pitchdeckData = state.VSProduct.pitchdeck_data;
    const fileData = state.VSProduct?.fileData;
    const bodyData: any = {
      userId: String(user_id), // Convert userId to string
      threadId: String(thread_id),
      industry: agentName === "Patent Licensing Agent" ? "packaging" : "AI",
      agent: agentName
        ? Object.keys(ipExperts).includes(agentName || "")
          ? ipExperts[agentName]
          : agentName || "Startup Diligence Agent"
        : "Startup Diligence Agent",
      // agentName === "Prior Art Agent"
      //   ? "prior_art_agent"
      //   : agentName === "Patent Licensing Agent"
      //   ? "patent-license-agent"
      //   : agentName || "Startup Diligence Agent",
      useCase: agentName === "Patent Licensing Agent" ? "licensing-out" : "AI",
      step: 0,
      // agentName === "Prior Art Agent" || agentName === "Patent Licensing Agent" ? step :
      data: { user_input: sendPitchData ? JSON.stringify(pitchdeckData) : user_input },
      file_upload_status: file_upload_status ? file_upload_status : false,
      ...(sendPitchData
        ? { file_upload_url: { [fileData.original_filename]: fileData.file_url } }
        : {}),
    };
    console.log("SLDKLSKDLKSLKDLKSD",jsonType)
    if (jsonType === "Data_sources") {
      bodyData.additional_data_sources = state.VSProduct.additionalDataSources || null;
    } else if (jsonType === "Final_report") {
      bodyData.additional_report_template = state.VSProduct.additionalReportTemplate || null;
    }
    //  else if (jsonType === "keywords") {
    //   bodyData.data.user_input  = `${user_input} ${state.VSProduct.additionalKeywords?.length ? "added these - " :""} ${ (state.VSProduct.additionalKeywords || [])?.join(" ")}`
    // }
    // const bodyData = {
    //   userId: "272",
    //   threadId: "1490",
    //   industry: "packaging",
    //   agent: "patent-license-agent",
    //   useCase: "licensing-out",
    //   step: 6,
    //   data: { user_input: "continue please" },
    //   file_upload_status: false,
    // };
    const endpoint = `${API_PROD_URL}${
      Object.keys(ipExperts).includes(agentName || "") ? "/multi-agent" : ""
    }/process-step`;
    const response: any = await axios.post(endpoint, bodyData, {
      headers: { "Content-Type": "application/json" },
      responseType: "stream",
    });
    // return {
    //   data: {
    //     userId: "272",
    //     threadId: "1541",
    //     step: 6,
    //     status: "Complete",
    //     prompt: "proceed further",
    //     response:
    //       "Almost there! \n\n The final stencil of your report is ready in the right pane. Customize them to match your vision \n                        before submission.\n\n- Review the Template: Take a moment to go through each section and subsection to ensure\n                        it covers all necessary aspects.\n\n- Add or Modify Sections: If there are any specific areas you would like to add or modify,\n                        feel free to do so.",
    //     json_response: {
    //       sections: {
    //         "1": {
    //           title: "Market Opportunity",
    //           summary:
    //             "An overview of the market size, growth rate, and target audience for clean energy solutions.",
    //           body: "Market Size: $300 billion global smart home market, $50 billion subset for clean energy solutions. Growth Rate: 8.9% CAGR in the smart home energy management sector. Target Audience: Homeowners and commercial properties looking to reduce energy costs and carbon footprints.",
    //           subsections: {
    //             "1.1": {
    //               title: "Target Audience Analysis",
    //               summary:
    //                 "Detailed analysis of the demographics and psychographics of the target audience.",
    //               body: "Homeowners seeking sustainable energy solutions. Commercial properties aiming to lower operational costs and carbon footprints.",
    //             },
    //           },
    //         },
    //         "2": {
    //           title: "Competitive Differentiation",
    //           summary: "A comparison of Ecotech Innovations with key competitors in the market.",
    //           body: "Competitors: Tesla Powerwall, Sunrun, Vivint Solar. Differentiation: AI-driven optimization and seamless integration with existing home systems.",
    //           subsections: {
    //             "2.1": {
    //               title: "Competitive Landscape Overview",
    //               summary: "An overview of the current competitive landscape.",
    //               body: "Analysis of competitors' strengths and weaknesses. Unique value proposition of Ecotech Innovations.",
    //             },
    //           },
    //         },
    //         "3": {
    //           title: "Product Viability",
    //           summary:
    //             "Assessment of the product's feasibility and potential impact on the market.",
    //           body: "Product: Solar-powered smart home energy systems. Key Features: AI-driven energy optimization, seamless integration with existing home systems, scalable for commercial use.",
    //           subsections: {
    //             "3.1": {
    //               title: "Product Features Analysis",
    //               summary: "Detailed analysis of product features and benefits.",
    //               body: "Benefits to homeowners and commercial properties. Potential savings on energy bills (up to 30%).",
    //             },
    //           },
    //         },
    //         "4": {
    //           title: "Founding Team Overview",
    //           summary: "Introduction to the founding team members and their expertise.",
    //           body: "CEO: Jane Doe (10+ years in clean tech, ex-SolarCity). CTO: John Smith (AI expert, PhD in Machine Learning). COO: Emily Johnson (Operations lead, previously at Tesla).",
    //           subsections: {
    //             "4.1": {
    //               title: "Team Members Profiles",
    //               summary: "Detailed profiles of each team member.",
    //               body: "Background, experience, and contributions to Ecotech Innovations.",
    //             },
    //           },
    //         },
    //         "5": {
    //           title: "Go-to-Market Strategy",
    //           summary: "Plan for launching Ecotech Innovations’ products into the market.",
    //           body: "Channels: Direct-to-consumer via digital marketing. Partnerships with home builders and utility companies. B2B for commercial installations.",
    //           subsections: {
    //             "5.1": {
    //               title: "Customer Acquisition Cost (CAC) vs Lifetime Value (LTV)",
    //               summary: "Analysis of customer acquisition costs versus lifetime value.",
    //               body: "Customer Acquisition Cost (CAC): $120. Lifetime Value (LTV): $900.",
    //             },
    //           },
    //         },
    //         "6": {
    //           title: "Customer Validation",
    //           summary: "Evidence supporting customer demand for Ecotech Innovations’ products.",
    //           body: "Traction & Milestones: Units Sold: 1,500 units in first 12 months. Partnerships: With 3 utility providers. Annual Recurring Revenue (ARR): $1.2M from subscriptions. Customer Feedback: Average customer savings 25% on energy bills.",
    //           subsections: {
    //             "6.1": {
    //               title: "Customer Feedback Analysis",
    //               summary:
    //                 "Detailed analysis of customer feedback on Ecotech Innovations’ products.",
    //               body: "Compilation of testimonials, surveys, and case studies demonstrating product effectiveness.",
    //             },
    //           },
    //         },
    //         "7": {
    //           title: "Revenue Model Analysis",
    //           summary: "Overview of revenue streams for Ecotech Innovations.",
    //           body: "Revenue Streams: Direct Sales: Solar-powered systems sold to homeowners & businesses. Subscription: Monthly energy management services via AI-driven software. Partnerships: Partnering with utility companies to provide grid support.",
    //           subsections: {
    //             "7.1": {
    //               title: "Revenue Streams Breakdown",
    //               summary: "Detailed breakdown of each revenue stream.",
    //               body: "Analysis projections, future growth potential, and sustainability.",
    //             },
    //           },
    //         },
    //         "8": {
    //           title: "Operational Efficiency",
    //           summary:
    //             "Assessment of operational efficiency within Ecotech Innovations’ processes.",
    //           body: "Review current operations, identifying areas for improvement, growth, and scalability.",
    //           subsections: {
    //             "8.1": {
    //               title: "Operational Metrics Analysis",
    //               summary: "Analysis of key metrics related to operational efficiency.",
    //               body: "Evaluation of production timelines, costs, and resource allocation.",
    //             },
    //           },
    //         },
    //         "9": {
    //           title: "Partnerships & Alliances",
    //           summary:
    //             "Overview of strategic partnerships & alliances for growth & market penetration.",
    //           body: "Details of existing partnerships with utility providers & home builders.",
    //           subsections: {
    //             "9.1": {
    //               title: "Strategic Partnership Opportunities",
    //               summary: "Identification of new partnership opportunities.",
    //               body: "Potential collaborations with industry leaders, technology providers, & government agencies.",
    //             },
    //           },
    //         },
    //         "10": {
    //           title: "Technology & IP Overview",
    //           summary:
    //             "Overview of technology used by Ecotech Innovations & its intellectual property (IP) portfolio.",
    //           body: "Description of proprietary software, patents filed, and competitive edge.",
    //           subsections: {
    //             "10.1": {
    //               title: "Technology Impact Assessment",
    //               summary:
    //                 "Assessment of the impact of technology on product performance & market differentiation.",
    //               body: "Evaluation of AI-driven optimization algorithms & energy storage technology.",
    //             },
    //           },
    //         },
    //         "11": {
    //           title: "Regulatory & Compliance Review",
    //           summary:
    //             "Review of regulatory requirements and compliance measures for operating in target markets.",
    //           body: "Description of relevant regulations, safety standards, and environmental guidelines.",
    //           subsections: {
    //             "11.1": {
    //               title: "Compliance Strategy",
    //               summary: "Plan ensuring ongoing compliance with all regulatory requirements.",
    //               body: "Steps taken to maintain compliance and mitigate risks associated with regulatory changes.",
    //             },
    //           },
    //         },
    //         "12": {
    //           title: "Time-to-Market",
    //           summary: "Estimated timeline for product launch and expansion into new markets.",
    //           body: "Project milestones, key dependencies, and potential challenges impacting time-to-market.",
    //           subsections: {
    //             "12.1": {
    //               title: "Timeline Breakdown",
    //               summary: "Detailed breakdown of the projected timeline.",
    //               body: "Step-by-step plan from development to launch and expansion phases.",
    //             },
    //           },
    //         },
    //         "13": {
    //           title: "Market Momentum",
    //           summary: "Current momentum within target market for sustainable energy solutions.",
    //           body: "Analysis of industry trends, growth drivers, and consumer adoption rates.",
    //           subsections: {
    //             "13.1": {
    //               title: "Trend Analysis",
    //               summary: "Detailed analysis of emerging trends impacting the target market.",
    //               body: "Evaluation of technological advancements, increasing consumer awareness, and policy changes.",
    //             },
    //           },
    //         },
    //         "14": {
    //           title: "Cost of Acquisition",
    //           summary:
    //             "Overview of the cost of acquiring new customers for Ecotech Innovations’ products.",
    //           body: "Analysis of marketing expenses, strategy effectiveness, and return on investment (ROI).",
    //           subsections: {
    //             "14.1": {
    //               title: "Cost Breakdown",
    //               summary: "Detailed breakdown of the cost of acquisition.",
    //               body: "Evaluation of each marketing channel and strategy efficiency.",
    //             },
    //           },
    //         },
    //         "15": {
    //           title: "Product Scalability",
    //           summary:
    //             "Assessment of scalability potential of Ecotech’s solar-powered smart home energy systems.",
    //           body: "Review of system design, supply chain capabilities, and scalability plans.",
    //           subsections: {
    //             "15.1": {
    //               title: "Scalability Plan",
    //               summary: "Detailed plan for scaling production to meet growing demand.",
    //               body: "Steps taken to ensure scalability without compromising quality or efficiency.",
    //             },
    //           },
    //         },
    //       },
    //     },
    //     status_main: false,
    //     type_json: "Final_report",
    //   },
    // };
    if (sendPitchData) {
      return response;
    } else {
      return response;
    }

    return;
  },
);

export const endChatThread = createAsyncThunk(
  "chatEnded",
  async (
    {
      user_id,
      thread_id,
    }: {
      user_id: string;
      thread_id: string;
    },
    { getState },
  ): Promise<any> => {
    const response: any = await axios.patch(
      `${API_PROD_URL}/update_thread_complete/?user_id=${user_id}&thread_id=${thread_id}`,
      {},
      { headers: { "Content-Type": "application/json" }, responseType: "stream" },
    );
    return response
  },
);

export const submitCustomizeReport = createAsyncThunk(
  "submitCustomizeReport",
  async (payload: any, { getState }): Promise<any> => {
    const response: any = await axios.post(`${API_PROD_URL}/api/threads/report-config`, payload, {
      headers: { "Content-Type": "application/json" },
      responseType: "stream",
    });
    return response;
  },
);

export const submitGuestUser = createAsyncThunk(
  "submitGuestUser",
  async (payload: { email: string }, { getState }): Promise<any> => {
    const response: any = await axios.post(`${API_PROD_URL}/guest/register`, payload, {
      headers: { "Content-Type": "application/json" },
      responseType: "stream",
    });
    return response;
  },
);

export const fetchCustomizeReport = async (
  thread_id: string,
  userId: string,
  callback: (value: { customReport: any; loading: boolean }) => void,
) => {
  try {
    const response = await fetch(
      `${API_PROD_URL}/api/threads/${thread_id}/report-config?user_id=${userId}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      },
    );

    if (response.ok) {
      const data = await response.json();
      callback({
        customReport: data || {},
        loading: false,
      });
    }
  } catch (err) {
    console.error(err);
    callback({
      customReport: {},
      loading: false,
    });
  } finally {
    // setLoading(false);
  }
};
